/** Conversão HSL → 0xRRGGBB. */
export function hslToHex(h: number, s: number, l: number): number {
  const a = s * Math.min(l, 1 - l);
  const f = (n: number): number => {
    const k = (n + h / 30) % 12;
    return Math.round(255 * (l - a * Math.max(-1, Math.min(k - 3, Math.min(9 - k, 1)))));
  };
  return (f(0) << 16) | (f(8) << 8) | f(4);
}

export interface PaletteColors {
  base: number;
  midLight: number;
  light: number;
  dark: number;
  shadow: number;
  glare: number;
}

export function paletteFromHue(hue: number): PaletteColors {
  const h = ((hue % 360) + 360) % 360;
  return {
    base: hslToHex(h, 0.65, 0.6),
    midLight: hslToHex(h, 0.62, 0.74),
    light: hslToHex(h, 0.6, 0.85),
    dark: hslToHex(h, 0.7, 0.3),
    shadow: hslToHex(h, 0.7, 0.38),
    glare: 0xffffff,
  };
}
